import React from 'react';

import { media } from '@atlaskit/primitives';
import Inline from '@atlaskit/primitives/inline';
// eslint-disable-next-line @townsquare/rules/no-xcss
import { xcss } from '@atlaskit/primitives/xcss';

const styles = xcss({
	gridArea: 'actions',
	[media.above.xxs]: {
		marginBlockStart: 'space.200',
	},
	[media.above.sm]: {
		marginInlineStart: 'auto',
		marginBlockStart: 'unset',
	},
});

export const Actions = ({ children }: React.PropsWithChildren<unknown>): React.JSX.Element => {
	return (
		<Inline space="space.100" xcss={styles} shouldWrap>
			{children}
		</Inline>
	);
};
